import React from "react";
import { useTranslation } from "react-i18next";

const Statement: React.FC = () => {
  const { t } = useTranslation();
  const items = Array.from({ length: 3 });

  return (
    <section
      aria-label={t("statement.text")}
      className="relative overflow-hidden bg-[#171411] text-cream border-y border-white/10"
    >
      <div className="py-5 sm:py-6 overflow-hidden">
        <div
          className="dem-statement-track flex w-max items-center will-change-transform"
        >
          {[0, 1].map((group) => (
            <div
              key={group}
              className="flex min-w-[100vw] shrink-0 items-center justify-around gap-7 sm:gap-10 pr-7 sm:pr-10"
              aria-hidden={group === 1 ? "true" : undefined}
            >
              {items.map((_, index) => (
                <React.Fragment key={`${group}-${index}`}>
                  <p className="whitespace-nowrap font-oswald font-light uppercase tracking-[0.16em] text-base sm:text-lg lg:text-2xl leading-none text-white/85">
                    {t("statement.text")}
                  </p>
                  <span
                    className="relative block h-3.5 w-3.5 shrink-0"
                    aria-hidden="true"
                  >
                    <span className="absolute left-1/2 top-0 h-full w-px -translate-x-1/2 bg-gradient-to-b from-transparent via-[#b99173] to-transparent" />
                    <span className="absolute left-0 top-1/2 h-px w-full -translate-y-1/2 bg-gradient-to-r from-transparent via-[#b99173] to-transparent" />
                    <span className="absolute left-1/2 top-1/2 h-1.5 w-1.5 -translate-x-1/2 -translate-y-1/2 rotate-45 bg-[#b99173]" />
                  </span>
                </React.Fragment>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Statement;
